<template lang="pug">
  .main
    .load(v-if="!response || spinnerON")
      v-icon(name="spinner" spin scale="3" style="color: #ccc")
    .data(v-else)
      .pagination_wrapper.more(v-if="this.$parent.maxPages>1")
        .navTop
          .pagination_grid
            button(@click="prevPage" v-if="reversedPage>1")
              span &lsaquo;
            button(@click="nextPage" v-if="reversedPage<this.$parent.maxPages")
              span &rsaquo;
            span.pages {{this.$parent.page}}/{{this.$parent.maxPages}}
      table(v-if="response && response.length")
        tr
          th.tableTitle(v-for="col in cols" v-html="col.title")
        tr(v-for="item in response" )
          td(v-if="editable === false" v-for="col in cols") {{item[col.key] || '—'}}
          td.link(v-if="editable !== false" v-for="col in cols")
            router-link.hoverLink(:to='{ name: nextState, params: itemToRouteParam(item) }' target="_blank"  v-if="linkCondition(col, nextState, item)")
              a {{nonBreakingSpacesReplacement(item[col.key]) || '—'}}
            span(v-if="!linkCondition(col, nextState, item)") {{nonBreakingSpacesReplacement(item[col.key]) || '—'}}
            span(v-if="iconFiels && col.key === iconFiels.key") &ensp;
              v-icon(:name="iconFiels.iconName" :class="iconFiels.getClass(item[col.key])")

      .pagination_wrapper.more(v-if="this.$parent.maxPages>1")
        nav
          .pagination_grid
            // «
            button(@click="goToFirstPage" v-if="reversedPage>1 && this.$parent.maxPages>7")
              span &laquo;
            // ‹
            button(@click="prevPage" v-if="reversedPage>1")
              span &lsaquo;
            button(v-for="page in this.$parent.maxSize" @click="goToPage(page)" :class="reversedPage == page ? 'activatePages' : ''" v-bind:disabled="reversedPage == page ? true : false")
              span {{ page }}
            // ›
            button(@click="nextPage" v-if="reversedPage<this.$parent.maxPages")
              span &rsaquo;
            // »
            button(@click="goToLastPage" v-if="reversedPage<this.$parent.maxPages && this.$parent.maxPages>7")
              span &raquo;
      .not_found(v-if="response && !response.length")
          .red.dateFail(v-if="dateFail")
            v-icon(name="exclamation-circle" scale="1.7" )
            span  &emsp; Дата окончания периода не может быть раньше даты начала

          span(v-if="!dateFail") Записей не найдено
            div
              v-icon(name="folder-open" scale="1.7" style="margin-top: 8px")
</template>
<script>
import Icon from 'vue-awesome/components/Icon'
export default {
  components: {
    'v-icon': Icon
  },
  data () {
    return {
      spinnerON: false,
      loading: false,
      dateFail: false
    }
  },
  props: ['cols', 'response', 'nextState', 'count', 'editable', 'iconFiels'],
  methods: {
    nonBreakingSpacesReplacement (str) {
      if (typeof str === 'string') {
        return str.split('\u00A0').join(' ')
      } else return str
    },
    itemToRouteParam (item) {
      if (item.alias) {
        return { id: item.id, alias: item.alias, parentID: item.parentID }
      }
      if (item.api_version) {
        return { id: item.id, api_version: item.api_version || '-' }
      } else return { id: item.id }
    },
    linkCondition (col, nextState, item) {
      let colCondition = col.key === 'id' || col.key === 'name' || col.key === 'hospital_name'
      let nextStateCondition = nextState === 'DirectoryEdit'
      // для ссылки нужна истина
      let itemCondition = !!item.api_version || !!item.alias
      if (nextStateCondition) {
        return colCondition && itemCondition
      } else {
        return colCondition
      }
    },
    nextPage () {
      this.$parent.nextPage()
      this.goTop()
    },
    prevPage () {
      this.$parent.prevPage()
      this.goTop()
    },
    goToFirstPage () {
      this.$parent.goToFirstPage()
      this.goTop()
    },
    goToLastPage () {
      this.$parent.goToLastPage()
      this.goTop()
    },
    goToPage (page) {
      this.$parent.goToPage(page)
      this.goTop()
    },
    goTop () {
      document.location.href = '#main'
    }
  },
  computed: {
    reversedPage: function () {
      return this.$parent.page
    }
  }
}
</script>
<style lang="sass" scoped>
.main
  padding-bottom: 10px
  margin: 0 15px
  position: relative
  top: -15px
.load
  display: flex
  justify-content: center
  align-items: center
  min-height: 300px
table
  position: relative
  font-family: 'Roboto', Helvetica, Arial, sans-serif
  width: 100%
  border-collapse: collapse
  padding-left: 20px
.tableTitle
  color: #555
th, td
  padding: 10px 20px
th
  font-weight: 450
  text-align: left
  height: 50px
td
  height: 35px
  font-size: 17px
a
  text-decoration: inherit
.link:first-child
  color: #2357a4
  font-weight: bold
  padding-right: 10px
tr:not(:last-child)
  border-bottom: 1px solid #ccc
.hoverLink:hover
  cursor: pointer
  background: #ebf7f9
  transition: all 0.2s
.more
  margin: 40px 0 20px 0
  text-align: center
.not_found
  margin-top: 5px
  padding: 40px
  text-align: center
  border-top: 1px dotted #ccc
  font-size: 18px
.more button
  background: white
  border-radius: 5px
  border: 1px solid #ccc
  font-size: 15px
  padding: 10px
.more button:hover
  background: #e6e6e6
.dateFail
  display: flex
  align-items: center
  justify-content:  center

// ICON CLASSES
.red
  color: #e53935
  margin-left: 5px
.yellow
  color: #f09908
  margin-left: 5px
.green
  color: #1aa020
  margin-left: 5px
.gray
  color: #d4d4cc
  margin-left: 5px
.blue
  color: #2357a4
  display: flex
  align-items: center
  justify-content:  center

// pagination
.pagination_wrapper
  text-align: center
  color: #555
  font-weight: bold

.pagination_grid > button
  min-width: 50px
  min-height: 40px
  padding: 6px
  font-size: 18px

.navTop > .pagination_grid
  justify-content: flex-end

.navTop > .pagination_grid > button
  min-width: 50px
  min-height: 40px
  padding: 6px
  font-weight: bold
  font-size: 20px

.navTop
  text-align: right

.pages
  padding: 15px
.activatePages > span
  color: #2357a4
  font-weight: bold
  font-size: 26px
@media screen and (max-width: 1120px)
  th, td
    padding-left: 10px
@media screen and (max-width: 1030px)
  .main
    padding: 15px
  table
    width: 95vw
  th, td
    padding-left: 4px
    padding-right: 4px
</style>
